// src/admin/hooks/useAdmin.js
// Admin-side counterpart to lib/useMerchant.js's useMerchant(). Same three
// checks on mount: bounce to /admin/login if no token, fetch /admin/me,
// clear + bounce if that call fails (expired/revoked token).

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import adminApi from "@/admin/lib/adminApi";
import { getAdminSession, clearAdminSession } from "@/admin/lib/adminAuth";

export function useAdmin() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const s = getAdminSession();
    if (!s?.token) {
      navigate("/admin/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await adminApi.get("/admin/me");
        setAdmin(data);
      } catch {
        clearAdminSession();
        navigate("/admin/login", { replace: true });
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return { admin, loading, setAdmin };
}

export function isSuperAdmin(admin) {
  return admin?.role === "super_admin";
}
